<template>
  <div>
    <div class="right-title">
      <span>{{name}}实习生申请表</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="search-box">
        <div>
<!--          <el-button type="primary" @click="type=1">按学校分</el-button>-->
          <el-button type="danger"  @click="type=2" style="margin-right: 10px;">按用人单位分</el-button>
        </div>
        <div>
          <el-input
              class="search"
              type="text"
              prepend="iconbianji1"
              placeholder="请输入关键字"
              v-model="search"
          >
          </el-input>
          <el-button @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>
        </div>

      </div>
      <div class="tab-box">

        <el-collapse v-model="activeNames">
          <el-collapse-item  :name="index" v-for="(item,index) in tableData" :key="index">
            <template slot="title">
              <h3 style="color: #00a2ea;font-size: 16px;font-weight: bold;">{{ item.orgName }}</h3>
            </template>
            <el-table
                ref="multipleTable"
                :data="item.list"
                tooltip-effect="dark"
                style="width: 100%;height: 100%"
                :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
            >

              <el-table-column
                  prop="user_real_name"
                  label="姓名"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="user_name"
                  label="手机号"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="enroll"
                  label="录用"
                  align="center"
              >
              </el-table-column>

              <el-table-column
                  label="查看详情"
                  align="center"
              >
                <template slot-scope="scope">
                  <span class="hal-cursor hals-color" @click="toDetail(scope.row.resume_id)">查看详情</span>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>

        </el-collapse>



        <div class="page-box">
          <div>
            共计{{page.pageTotal}}条
          </div>
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page.pageNum"
              :page-size="page.pageSize"
              layout="prev, pager, next, jumper"
              :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
import footerBox from '../components/rightBottom'

export default {
  name: "applyList",
  data() {
    return {
      name:'',
      search: '',  // 搜索
      tableData: [],
      type:2,  //  1 学校 2 单位
      multipleSelection: [], //  选中的
      page: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 1
      },
      activeNames:[0,1,2,3,4,5,6,7,8,9]
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    this.name = this.$route.query.name
    this.$emit('setType', 1)
    this.baoming()
  },
  methods: {
    // 机构列表
    baoming() {
      const loading = this.$loading({
        target: this.$refs.listBox,
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      if (this.$route.query.pageNum) {
        this.page.pageNum = Number(this.$route.query.pageNum)
      } else {
        this.page.pageNum = 1
      }
      if (this.$route.query.key) {
        this.search = this.$route.query.key
      } else {
        this.search = ''
      }
      if (this.$route.query.type) {
        this.type = Number(this.$route.query.type)
      } else {
        this.type = 0
      }
      this.$api.apiContent.showSHXCandidateList({
        adminId: this.user.id,
        sxhId: this.$route.query.id,
        searchShowType:this.type,
        searchName: this.search,
        page: this.page.pageNum,
        pageSize: this.page.pageSize,
      }).then(res => {
        loading.close();
        this.page.pageNum = res.now_page
        this.page.pageTotal = res.total_number
        this.tableData = res.data
        this.tableData.map(item => {
          item.is_show = item.is_show === 0 ? (true) : (false)      //  双选会
          item.is_nationwide = item.is_nationwide === 0 ? (true) : (false)  //  全国
        })
      }).catch(() => {
        loading.close();
        this.tableData = []
        this.page.pageTotal = 0
      })

    },
    //简历详情
    toDetail(id) {
      this.$router.push({
        path: '/home/hxrAdmin/hxrResume?resumeId=' + id
      })
    },
    handleSizeChange(num) {        //  点击分页
      this.page.pageNum = num
    },
    handleCurrentChange(num) {     //  选择页数
      this.page.pageNum = num
    },
    keyWord() {     //  搜索
      if (this.page.pageNum === 1) {
        this.setPath()
      } else {
        this.page.pageNum = 1
      }
    },
    //  修改路径
    setPath() {
      this.$router.push({
        path: '/home/meetAdmin/applyList',
        query: {
          pageNum: this.page.pageNum,
          key: this.search,
          type: this.type,
          id:this.$route.query.id,
          name:this.$route.query.name
        }
      })
    },
    goBack() {     //  返回上一页
      this.$tools.goBack2()
    },
  },
  watch: {
    'page.pageNum'() {
      this.setPath()
    },
    type(){
      this.page.pageNum =1
      this.setPath()
    },
    $route() {
      this.baoming()
    }
  },
  components: {
    footerBox
  }
}
</script>

<style scoped lang="scss">
.search-box {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 1;
  display: flex;
  justify-content: space-between;

  .search {
    width: 220px;
  }
}

.tab-box {
  position: relative;
  /*top: 64px;*/
  /*left: 10px;*/
  /*right: 10px;*/
  /*bottom: 60px;*/
  min-height: 100%;
  padding-top: 50px;
  padding-bottom: 60px;
  background: #fff;


  .page-box {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

</style>